import Header from '../components/Header';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import Seo from '../components/Seo';


const NotFound = () => {
    const { t } = useTranslation();
    return (
        <>
         <Seo
        title={"Page not found | Feeling Italy"}
        description={"The page you’re looking for on Feeling Italy is not available. Check our homepage or explore our website for exclusive Mediterranean villa rentals and personalized travel experiences."}
        keywords={"404 Page Not Found, Feeling Italy Error Page, Broken Link, Missing Page, Mediterranean Vacation Rentals, Amalfi Coast Villas, Luxury Travel Assistance, Website Navigation, Page Not Found Error, Villa Booking Help"}
      />
            <Header background={"white"} />
            <div className="background-white pTop vh-70">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-md-12 col-12">
                            <h1 className="title mt-5 mb-3 text-center text-black text-uppercase">{t("PageNotFound")}</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <p className="paragraph text-center">
                            {t("PageNotExist")} <br />
                            {t("ContactOurConcierge")}
                            </p>
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-md-12 col-12">
                            <p className="paragraph text-center">
                            <NavLink className={"link lineEffectBlack text-uppercase text-black"} to="/">{t("GoBackHome")}</NavLink>

                            </p>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default NotFound;
